import React, { useReducer, useEffect, useState } from "react"
import { HashRouter as Router } from "react-router-dom"

import RouterView from "./Router"
import { initialState, ContextStore, reducer } from "./Reducer/index"
import packageJson from "../package.json"
import GlobalStyle from "Css/globalStyle"
import { ThemeProvider } from "styled-components"
import themeStyle from "Css/style"
import { useTranslation } from "react-i18next"
import { title } from "config/title"
//
import Auth from "Components/Auth"
import useAddGa from "useHooks/useAddGA"

function App() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { stateReducer } = state
  const theme = stateReducer.get("theme")
  const [httpTitle, setHttpTitle] = useState("CQ9 游戏大厅")
  const lang = stateReducer.get("lang")
  const { i18n } = useTranslation()

  useEffect(() => {
    i18n.changeLanguage(lang)
  }, [i18n, lang])

  useEffect(() => {
    setHttpTitle(title[lang])
    document.title = httpTitle
  }, [httpTitle, lang])
  // add GA to master
  useAddGa()

  return (
    <ContextStore.Provider value={{ state, dispatch }}>
      <ThemeProvider theme={themeStyle[theme]} test={theme}>
        <>
          <div data-version={packageJson.version} />
          <GlobalStyle />
          <Router>
            <Auth />
            <RouterView />
          </Router>
        </>
      </ThemeProvider>
    </ContextStore.Provider>
  )
}

export default App
